import React from 'react';

/**
 * Reusable animated loading shell shown while flight search is in progress.
 * Used in both SearchFlights (BookFlights) and Home (AIR Weekly) pages.
 *
 * Props:
 *   badge      {string}   - Short badge label, e.g. "Scanning departure fares"
 *   title      {string}   - Heading line, e.g. "Curating your takeoff options"
 *   message    {string}   - Body sentence with route/date detail
 *   status     {string}   - Live status line shown near the plane animation
 *   metaItems  {string[]} - 2–4 small meta chips shown below (travellers, route, etc.)
 *   isExiting  {boolean}  - Triggers the exit fade-out animation
 */
function SearchLoadingShell({ badge, title, message, status, metaItems = [], isExiting = false }) {
  return (
    <div
      className={`search-loading-shell${isExiting ? ' search-loading-shell--exiting' : ''}`}
      aria-live="polite"
    >
      <div className="search-loading-shell__glow" />
      <div className="search-loading-shell__content">
        <div className="search-loading-shell__badge">{badge}</div>
        <h3>{title}</h3>
        {message && <p>{message}</p>}
        {status && (
          <div className="search-loading-shell__status">
            <span className="search-loading-shell__status-text">{status}</span>
          </div>
        )}
        <div className="search-loading-shell__flight-path" aria-hidden="true">
          <svg
            className="search-loading-shell__path-svg"
            viewBox="0 0 280 44"
            preserveAspectRatio="none"
          >
            <path
              className="search-loading-shell__path-curve"
              d="M 12 30 C 62 8, 110 6, 162 20 S 232 37, 268 18"
            />
          </svg>
          <span className="search-loading-shell__cloud search-loading-shell__cloud--start" />
          <span className="search-loading-shell__trail search-loading-shell__trail--one" />
          <span className="search-loading-shell__trail search-loading-shell__trail--two" />
          <span className="search-loading-shell__plane">✈</span>
          <span className="search-loading-shell__cloud search-loading-shell__cloud--end" />
        </div>
        {metaItems.filter(Boolean).length > 0 && (
          <div className="search-loading-shell__meta">
            {metaItems.filter(Boolean).map((item, i) => (
              <span key={i}>{item}</span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default SearchLoadingShell;
